<script>
    export default {
        props: {
            initialMessages: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                messages: this.initialMessages,
                checkedMessageIds: [],
                allChecked: false,
            };
        },

        computed: {
            shouldMarkCheckedButtonBeDisabled() {
                return ! this.checkedMessageIds.length;
            },
        },

        watch: {
            allChecked: function (value) {
                this.checkedMessageIds = value ? [...this.getMessageIds()] : [];
            },
        },

        methods: {

            getMessageIds() {
                return this.messages.map(message => message.id);
            },

            markCheckedAsRead() {
                this.updateMessagesReadStatus(true, 'markCheckedAsReadButton');
            },

            markCheckedAsUnread() {
                this.updateMessagesReadStatus(false, 'markCheckedAsUnreadButton');
            },

            async updateMessagesReadStatus(readStatus, buttonRef) {
                if (! this.checkedMessageIds.length) {
                    return;
                }

                // Optimistic UI, we assume the later API update will be successful
                this.setCheckedMessagesReadStatus(readStatus);

                // Reset checkboxes
                const messageIdsToUpdate = this.checkedMessageIds;
                this.checkedMessageIds = [];
                this.allChecked = false;

                this.$refs[buttonRef].classList.add('is-loading');
                try {
                    await axios.patch(route('front.my-pages.api.messages-read.update-multiple'), {
                        messageIds: messageIdsToUpdate,
                        read: readStatus,
                    });
                } catch (error) {
                    flash_error(error.response.data.message);
                }

                this.$refs[buttonRef].classList.remove('is-loading');
            },

            setCheckedMessagesReadStatus(readStatus) {
                this.messages = this.messages.map(message => {
                    if (this.checkedMessageIds.includes(message.id)) {
                        message.read = readStatus;
                        return message;
                    }

                    return message;
                });
            },

            isMessageRead(messageId) {
                const message = this.messages.find(message => message.id === messageId);

                return message && message.read;
            },

        },
    };
</script>
